import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/kaipin_laboratory",
  name: "kaipinLaboratory",
  component: function component() {
    return import("../../../views/member/kaipin_laboratory/index");
  },
  meta: {
    foot: true,
    title: "开品广场"
  }
}, {
  path: "/kaipin_my",
  name: "kaipin_my",
  component: function component() {
    return import("../../../views/member/kaipin_laboratory/my");
  },
  meta: {
    foot: true,
    title: "我的开品"
  }
}, {
  path: "/kaipin_details/:id",
  name: "kaipin_details",
  component: function component() {
    return import("../../../views/member/kaipin_laboratory/details");
  },
  meta: {
    foot: true,
    title: "开品详情"
  }
}, {
  path: "/kaipin_comment/:id",
  name: "kaipin_comment",
  component: function component() {
    return import("../../../views/member/kaipin_laboratory/comment");
  },
  meta: {
    foot: true,
    title: "全部评价"
  }
}, {
  path: "/kaipin_comment_details/:id",
  name: "kaipin_comment_details",
  component: function component() {
    return import("../../../views/member/kaipin_laboratory/comment_details.vue");
  },
  meta: {
    foot: true,
    title: "评价详情"
  }
}, {
  path: "/kaipin_publish_comment/:id",
  name: "kaipin_publish_comment",
  component: function component() {
    return import("../../../views/member/kaipin_laboratory/publish_comment.vue");
  },
  meta: {
    foot: true,
    title: "评价"
  }
}];